import type { Testimonial } from '@/types';

export const TESTIMONIALS: Testimonial[] = [
  {
    quote: '过去我们花三周摸到关键人，现在 48 小时内就能对上话。',
  },
  {
    quote: '投放团队最怕退信和石沉大海，联脉让线索不再"冷"。',
  },
];
